module.exports = __webpack_public_path__ + "img/shows-back.a68f87b6.png";